import { render, staticRenderFns } from "./ClinicDashboard.vue?vue&type=template&id=971efd1a&scoped=true"
import script from "./ClinicDashboard.vue?vue&type=script&lang=js"
export * from "./ClinicDashboard.vue?vue&type=script&lang=js"
import style0 from "./ClinicDashboard.vue?vue&type=style&index=0&id=971efd1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971efd1a",
  null
  
)

export default component.exports